import { render, staticRenderFns } from "./NewViewVendorPage.vue?vue&type=template&id=598bbd81&scoped=true&"
import script from "./NewViewVendorPage.vue?vue&type=script&lang=js&"
export * from "./NewViewVendorPage.vue?vue&type=script&lang=js&"
import style0 from "./NewViewVendorPage.vue?vue&type=style&index=0&id=598bbd81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bbd81",
  null
  
)

export default component.exports